export const getFileExtension = (fileName: string | File): string => {
    if (fileName instanceof File) {
        fileName = fileName.name;
    }

    return fileName.slice(((fileName.lastIndexOf('.') - 1) >>> 0) + 2);
};
